import Vue from 'vue';
import { Action } from '@/decorator/log';
import Base from './BaseStore';
import { PromiseEnd } from '@/utils/util';
import qs from 'qs';
import cloneDeep from 'lodash.clonedeep';
import qsObj from '@/utils/qs';
import errorHandler from './errorHandler';

// 我们不是作假 我是只是在Mock
import gDataMock from './mock/gdata.mock.js';
let g: any = gDataMock;
import mockCes from './mock/ces.mock.js';
import mockAjax from './mock/ajax.mock.js'; // 2d图谱和左右数据的mock
const mock3D = require('./mock/3d.mock.js');

import Config from '@root/config/env-config.js';
let pathPrefix = Config.pathPrefix;

if ($foodConfig.mode === 'ces') {
    pathPrefix = '/brain-api/ces';
} else {
    pathPrefix = '/brain-api';
}
interface Statistic {
    Entity: number;
    Relation: number;
    callCount: number[];
}

interface DetailStoreInterface {
    [propName: string]: any;
    statisticInfo?: any;
    userData?: any;
    poiData?: any;
    poiGraph?: any;
}

class DetailStore extends Base {
    poiGraph3d: any = {};
    state: DetailStoreInterface = {
        access: 200, // 403 401
        statisticInfo: {
            Relation: '',
            Entity: '',
            callCount: []
        },

        // 2d部分
        graphCnt: 0, // 多个图谱加载的时候的自增唯一ID
        userData: {},
        userGraph: {},
        poiData: {},
        poiGraph: {},
        graphInfo: {}, // subjectId, entityType 当前的图谱id和图谱类型

        // 3d部分
        poiData3d: {
            rootId: null,
            rootName: null,
            nodesCnt: '-',
            linksCnt: '-',
            relatedPOI: [
                { name: '麻小丨麻辣诱惑（君太店）', id: '1008936197508075588' },
                { name: '眉州东坡（中关村店）', id: '1008936832483758202' },
                { name: '东来顺饭庄（五道口店）', id: '1008936270543454330' }
            ]
        },
        poiGraph3d: {}, // 3d图谱

        loading: {
            global: true,
            main: true, // 中间的力导向图
            top: true, // 顶部的数据
            leftRight: true // 左右数据
        }
    };

    filterAjax(res) {
        if (res.code === 403) {
            debugger;
        }
    }

    @Action
    reset2dData () {
        this.state.userData = {};
        this.state.userGraph = {};
        this.state.poiData = {};
        this.state.poiGraph = {};
        this.state.graphInfo = {};
    }

    @Action
    changePoiGraph3d(data = {}) {
        this.state.poiGraph3d = {};
    }

    @Action
    changeAccess(access) {
        this.state.access = access;
    }

    @Action
    changeLoading({ type = 'global', flag = false }) {
        this.state.loading[type] = flag;
    }

    @Action
    async checkLogin() {
        try {
            let res = await this.$api({
                path: `${pathPrefix}/v1/username`,
                method: 'get',
                params: {}
            });
            if (res.status === 401) {
                throw new Error('小子 你没有登陆');
            }
        } catch (e) {
            console.dir(e);
            Vue.prototype.$message.error('没有登录' + e);
            throw new Error('小子 你没有登陆');
        }
    }

    // header中的统计信息
    @Action
    async getStatistic(subjectId?) {
        try {
            let res = await this.$api({
                path: `${pathPrefix}/v1/getStatistic`,
                method: 'get',
                params: {}
            });
            if (res.rescode === 403) {
                // this.state.access = false;
                if (mockAjax[subjectId] && mockAjax[subjectId]['getStatistic']) {
                    res = mockAjax[subjectId]['getStatistic'];
                }
            }
            this.state.statisticInfo = res.data;
        } catch (e) {
            let doNext = errorHandler(e, '顶部信息获取错误');
        }
        this.changeLoading({ type: 'top', flag: false });
        return this.state;
    }

    // 获取user左右数据
    @Action
    async getUserDataBySubjectId(subjectId) {
        this.changeLoading({ type: 'leftRight', flag: true });
        try {
            let res = await this.$api({
                path: `/brain-api/v1/getUserDataBySubjectId?subjectId=${subjectId}&isChineseName=1`,
                method: 'get',
                params: {}
            });
            this.state.userData = res.data;
            // TODO 我不想写这种代码 为什么要Hack
            for (let key in res.data.LeftData) {
                if (res.data.LeftData[key].length === 0) {
                    delete res.data.LeftData[key];
                }
            }
            this.state.poiData.isShow = false;
            this.state.userData.isShow = true;
        } catch (e) {
            let doNext = errorHandler(e, 'user中间信息获取错误');
        }
        this.changeLoading({ type: 'leftRight', flag: false });
        return this.state;
    }

    // 获取poi左右数据
    @Action
    async getPoiDataBySubjectId(subjectId) {
        try {
            this.changeLoading({ type: 'leftRight', flag: true });
            let recReasonAPI;
            if (mockAjax[subjectId] && mockAjax[subjectId]['recReasonAPI']) {
                recReasonAPI = cloneDeep(mockAjax[subjectId].recReasonAPI);
            } else {
                recReasonAPI = this.$api({
                    path: `${pathPrefix}/v1/getPoiRecreason?subjectId=${subjectId}`,
                    method: 'get', params: {}
                });
            }
            let poiDataAPI;
            if (mockAjax[subjectId] && mockAjax[subjectId]['poiDataAPI']) {
                poiDataAPI = cloneDeep(mockAjax[subjectId].poiDataAPI);
            } else {
                poiDataAPI = this.$api({
                    path: `${pathPrefix}/v1/getPoiDataBySubjectId?subjectId=${subjectId}&isChineseName=1`,
                    method: 'get', params: {}
                });
            }

            let res = await PromiseEnd([poiDataAPI, recReasonAPI]);

            if (!res.isResolve()) {
                let error = res.getReject();
                if (Array.isArray(error)) {
                    error = error[0] ? error[0] : error[1];
                }
                errorHandler(error, 'poi左右信息获取错误');
                return void 0;
            }
            let results = res.results;
            results.forEach((item, index) => {
                // switch case 并不好用
                if (index === 0 && item.done === true) {
                    let poiData = item.value.data;
                    // emotionComment data hack
                    try {
                        let emotionComment = poiData.RightData.emotionComment;
                        if (emotionComment) {
                            emotionComment.emotionMid = 1 - emotionComment.emotionPos - emotionComment.emotionNeg;
                            emotionComment.emotionMid = Number(emotionComment.emotionMid.toFixed(2));
                        }
                    } catch (e) {
                        console.log(e);
                    }
                    // 罪恶的删掉错误数据
                    console.log(poiData.RightData);
                    poiData.RightData.emotion.consume.pop();
                    poiData.RightData.emotion.date.pop();
                    poiData.RightData.emotion.mid.pop();
                    poiData.RightData.emotion.neg.pop();
                    poiData.RightData.emotion.pos.pop();
                    // 丑陋的hack
                    if(subjectId === '1008936890289655931') { // 黔诚酸汤牛肉
                        poiData.RightData.similarPoi = [
                            {mid: "-1", name: "煮意皇牛鲜牛肉火锅", score: 94},
                            {mid: "-1", name: "贵厨酸汤牛肉", score: 91},
                        ];
                    }
                    if (subjectId === '1008938677461594198') { // 眉州东坡上海中心
                        poiData.RightData.similarPoi = [
                            {mid: "-1", name: "尚海豆捞（乐虹坊店）", score: 96},
                            {mid: "-1", name: "天辣（长宁龙之梦店）", score: 90},
                        ];
                    }
                    this.state.poiData = poiData;
                    return void 0;
                }
                if (index === 1 && item.done === true) {
                    let recReason: string = item.value.data;
                    if (this.state.poiData) {
                        this.state.poiData.recReason = recReason;
                    }
                    return void 0;
                }
            });
            this.state.poiData.isShow = true;
            if (this.state.userData) {
                this.state.userData.isShow = false;
            }
            this.changeLoading({ type: 'leftRight', flag: false });
        } catch (e) {
            console.log(e);
            let doNext = errorHandler(e, 'poi左右信息获取错误');
        }

        return this.state;
    }

    fixGraphId(data) {
        let id = this.state.graphCnt;
        data.nodes.forEach((node) => {
            node.id_origin = node.id;
            node.id = `${id}_${node.id}`;
            node.clusterId = id;
        });
        data.links.forEach((link) => {
            link.source = `${id}_${link.source}`;
            link.target = `${id}_${link.target}`;
        });
        this.state.graphCnt++;
        return data;
    }

    mergeData (source, target) {
        let sourceNodes = source.nodes || [];
        let sourceLinks = source.links || [];
        let targetNodes = target.nodes || [];
        let targetLinks = target.links || [];
        let nodes = [...sourceNodes, ...targetNodes];
        let links = [...sourceLinks, ...targetLinks];
        return { nodes, links };
    }

    // https://brain.sankuai.com/brain-api/getPoiGraph?subjectId=1008936227346362484
    // 获取poi中间树形数据
    @Action
    async getPoiGraph({ subjectId, allValue= $foodConfig.poi2dAllValue, tagCountPerPoi= 5, dishCount= 5, tagCountPerDish= 5, isAppend=false }) {
        // 应该还没有使用 isAppend 变量的
        this.changeLoading({ type: 'main', flag: true });
        try {
            let res;
            if (mockAjax[subjectId] && mockAjax[subjectId]['getPoiGraph'] && allValue === 5) {
                res = cloneDeep(mockAjax[subjectId].getPoiGraph);
            } else {
                res = await this.$api({
                    // path: `/v1/getPoiGraph?subjectId=${subjectId}&tagCountPerPoi=${allValue}&dishCount=${allValue}&tagCountPerDish=${allValue}`,
                    path: `${pathPrefix}/v2/getPoiGraph?subjectId=${subjectId}&allValue=${allValue}`,
                    method: 'get',
                    params: {}
                });
            }
            // 清洗数据
            res.data.nodes.map(item => {
                item.rootId = subjectId;
            });

            let graphData = res.data;
            this.fixGraphId(graphData);
            if (isAppend) {
                graphData = this.mergeData(this.state.poiGraph, graphData);
            }
            this.state.poiGraph = graphData;
            this.state.graphInfo = {
                subjectId, entityType: 'poi'
            };
        } catch (e) {
            let doNext = errorHandler(e, 'poi中间信息获取错误');
        }
        this.changeLoading({ type: 'main', flag: false });
        return this.state;
    }

    async getPoiGraphOnly({ subjectId, allValue= $foodConfig.poi2dAllValue, tagCountPerPoi= 5, dishCount= 5, tagCountPerDish= 5, isAppend=false }) {
        try {
            let res = await this.$api({
                // path: `/v1/getPoiGraph?subjectId=${subjectId}&tagCountPerPoi=${allValue}&dishCount=${allValue}&tagCountPerDish=${allValue}`,
                path: `${pathPrefix}/v2/getPoiGraph?subjectId=${subjectId}&allValue=${allValue}`,
                method: 'get',
                params: {}
            });
            // let graphData = res.data;
            // let graphData:any = brainDataCes;
            let graphData = JSON.parse(JSON.stringify(mockCes.data));
            this.fixGraphId(graphData);
            return graphData;
        } catch (e) {
            let doNext = errorHandler(e, 'poi中间信息获取错误');
        }
    }

    // 获取user中间树形数据
    @Action
    async getUserGraph({ subjectId, allValue= 5, tagCountPerUser= 5, poiCount= 5, tagCountPerPoi= 5, dishCountPerPoi= 5 }) {
        this.changeLoading({ type: 'main', flag: true });
        try {
            let res = await this.$api({
                // path: `/v2/getUserGraph?subjectId=${subjectId}&allValue=${allValue}`,
                path: `${pathPrefix}/v3/getUserGraph?subjectId=${subjectId}&allValue=${allValue}`,
                method: 'get',
                params: {}
            });
            this.state.userGraph = res.data;
            this.state.graphInfo = {
                subjectId, entityType: 'user'
            };
        } catch (e) {
            let doNext = errorHandler(e, 'user左右信息获取错误');
        }
        this.changeLoading({ type: 'main', flag: false });
        return this.state;
    }

    // 获取3D数据
    @Action
    async getGraph3d() {
        // 讨厌的hack
        await $sleep(0);
        try {
            let rootId = this.state.graphInfo.subjectId || $foodConfig.poi3dMid; // 目前不是所有的图谱都有3d 只能写死
            // let rootId = $foodConfig.poi3dMid;
            if ($foodConfig.mode === 'ces') {
                rootId = $foodConfig.poi3dMid;
            }
            let resGraphData = null;
            if (mock3D[rootId]) {
                resGraphData = mock3D[rootId];
                if (qsObj.hoilday) {
                    resGraphData.nodes.forEach(node => {
                        if (node.depth === '0' && node.id === '1008938503825825874') {
                            node.name = '星怡会(朝阳合生汇店)';
                        }
                    });
                    let relatedPOI = resGraphData.nodes.filter(node => {
                        return node && node.depth === '0';
                    });
                    let rootIndex = relatedPOI.findIndex(node => {
                        return node.id === '1008938503825825874';
                    });
                    relatedPOI.splice(rootIndex, 1);
                    let updateName = [
                        '姜虎东白丁烤肉',
                        '赤火日式烧肉(三元桥店)',
                        '印度小厨',
                        '青柠泰餐厅(颐堤港店)',
                        '西贡妈妈(三里屯店)',
                        'Home Thai',
                        '小川料理',
                        '南大门米糕',
                        '文三酒肆',
                        '莲池印度餐厅',
                        'TUK TUK嘟嘟印度美食',
                        '姜虎东白丁烤肉',
                        '越打星YuetDaSing(凤凰汇店)'
                    ];
                    relatedPOI.slice(0,12).forEach((poi, i) => {
                        let nodeIndex = resGraphData.nodes.findIndex(n => n.name === poi.name);
                        let nodes = resGraphData.nodes[nodeIndex];
                        nodes.name = updateName[i];
                    });
                }
            } else {
                let queryObj: any = {
                    subjectId: rootId,
                    // allValue: 2 // 所有值统一处理

                    nearByPoiCount: 3, // 附近餐厅数量
                    simPoiCount: 3, // 相似餐厅数量
                    // //
                    dishCount: 2, // 推荐菜数量
                    tagCountPerPoi: 2, // 标签数量
                    envDistributionCount: 1,// 环境偏好对应poi变量控制
                    //
                    topPoiListSize: 2,
                    tagPoiCount: 2,// 标签关联poi数量
                    envPoiCount: 2 // 环境偏好标签数量
                    // allFlag: 1,
                };
                let url = `${pathPrefix}/v2/getPoi3dGraph?` + qs.stringify(queryObj);
                let res = await this.$api({ path: url, method: 'get', params: {} });
                resGraphData = res.data;
            }

            let gData = g.mergeGraph(
                // g.copyGraph(g.makeGraph(2), 1)
                // g.copyGraph(g.makeGraph(1), 50),
                // g.copyGraph(g.makeGraph(2), 30),
                // g.copyGraph(g.makeGraph(3), 20),
                // g.copyGraph(g.makeGraph(4), 10),
                // g.copyGraph(g.makeGraph(5), 10),
                // g.copyGraph(g.makeGraph(7), 10),
                resGraphData
            );

            // TODO报错处理
            // this.poiGraph3d = gData;
            this.state.poiGraph3d = gData;
            this.state.poiData3d = {
                rootId: rootId,
                rootName: resGraphData.nodes.find(_ => _.id === rootId).name,
                nodesCnt: resGraphData.nodes.filter(_ => _.depth === '0').length,
                linksCnt: resGraphData.links.length,
                relatedPOI: [
                    { name: '麻小丨麻辣诱惑（君太店）', id: '1008936197508075588' },
                    { name: '眉州东坡（中关村店）', id: '1008936832483758202' },
                    { name: '东来顺饭庄（五道口店）', id: '1008936270543454330' }
                ]
            };
            // this.state.poiGraph3d++;
        } catch (e) {
            let doNext = errorHandler(e, '3d数据获取失败');
            debugger;
        }
    }
}

const detail = new DetailStore();
export default detail;
